export default "__VITE_ASSET__D1i3NGEz__"